import React, { useState, useEffect } from "react";
import { Form, Spin } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import OtherCardForm from "./OtherCardForm";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import Endpoints from "../../api/endpoints";
import EndpointFunctions from "../../utils/Functions/endpointFunctions";
import PageRoutes from "../../utils/routes";

const UpdateOtherCard = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(null);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const params = useParams();
  const otherCardId = params.otherCardId;
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();

  useEffect(() => {
    fetchOtherCardDetails();
  }, []);

  const fetchOtherCardDetails = async () => {
    setIsLoading(true);
    const httpParams = { id: otherCardId };

    const result = await EndpointFunctions.fetchData({
      axiosPrivate: axiosPrivate,
      endpointURL: Endpoints.getOtherCard,
      httpParams: httpParams,
    });

    if (result.success) {
      setIsLoading(false);
      setInitialValues(result.data);
    } else {
      setIsLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  const updateOtherCard = async (values) => {
    setIsLoading(true);

    const requestBody = {
      id: otherCardId,
      companyName: values.companyName,
      color: values.color,
      isCommonlyUsed: values.isCommonlyUsed,
      status: values.status,
      barcodeFormat: null,
    };

    // Create FormData for file upload
    const formData = new FormData();
    const json = JSON.stringify(requestBody);
    const blob = new Blob([json], {
      type: "application/json",
    });
    formData.append("request", blob);

    if (values.logo) {
      formData.append("image", values.logo);
    }

    const result = await EndpointFunctions.postData({
      endpointURL: Endpoints.updateOtherCard,
      formData: formData,
      axiosPrivate: axiosPrivate,
      isMultiPart: true,
    });

    setIsLoading(false);

    if (result.success) {
      showModal("Başarılı", "Diğer kart başarıyla güncellendi.", () => {
        closeModal();
        navigate(PageRoutes.otherCards);
      });
    } else {
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  return (
    <div>
      <OtherCardForm
        form={form}
        onFinish={updateOtherCard}
        initialValues={initialValues}
        isLoading={isLoading}
      />
      <ModalComponent />
    </div>
  );
};

export default UpdateOtherCard;
